import { render, staticRenderFns } from "./zhenduan.vue?vue&type=template&id=0546a548&scoped=true&"
import script from "./zhenduan.vue?vue&type=script&lang=ts&"
export * from "./zhenduan.vue?vue&type=script&lang=ts&"
import style0 from "./zhenduan.vue?vue&type=style&index=0&id=0546a548&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546a548",
  null
  
)

export default component.exports